import { render } from "./SearchTabs.vue?vue&type=template&id=5119e779&scoped=true"
import script from "./SearchTabs.vue?vue&type=script&lang=js"
export * from "./SearchTabs.vue?vue&type=script&lang=js"

import "./SearchTabs.vue?vue&type=style&index=0&id=5119e779&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5119e779"]])

export default __exports__